
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { MstCouponVO } from '@/views/biz/coupon/vo/coupon.vo';
import Products from '@/components/Products.vue'
import CommonUtils from '@/common-utils';

@Component<CouponProducts>({ 
  components: {Products}
})
export default class CouponProducts extends Vue {
  // data
  coupon: MstCouponVO = {} as MstCouponVO;
  @Prop() couponCd!: string;
  @Prop() couponNm!: string;
  @Prop() description!: string;

  // initialized events
  created(): void {
    CommonUtils.setDocumentTitle([this.couponNm]);
    CommonUtils.setMetaDiscription(this.description);
    // 쿠폰 정보(단건)
    // axios.get(`/category/${this.couponCd}`)
    // .then((r) => {
    //   this.coupon = r.data as MstCouponVO;
    //   CommonUtils.setDocumentTitle([this.coupon.couponNm]);
    //   CommonUtils.setMetaDiscription(this.coupon.description);
    // });
  }  
}
